import CustomUserChip from "../../../../../components/CustomUserChip";
import {useRealTimeDuration} from "../../../../../Apis/functions";
import {IconChronometer} from "../../../../../components/buttons/IconButtons";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import React from "react";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 04 de diciembre de 2025
 */

const TimerChip = ({date}) => {
    const timer = useRealTimeDuration(date);
    return (
        <>
            <CustomUserChip
                className={`m-0 chip-primary-300-100 h-22px p-0 MuiChip-px-6px border-radius-4px minh-22px`}
                name={timer}
                showAvatar={true}
                Icon={IconChronometer}
                classNameIcon={`icon-color-primary-700 mt-0 p-0`}
                classNameText={`w-85px`}
                variant="large"
                iconPosition={POSITION_MODEL.LEFT}
            />
        </>
    )

}

export default TimerChip
